module.exports = __webpack_public_path__ + "img/owl-pink-left.b6a40ebb.png";